import moment from 'moment';
import { Text, View, Image, TouchableOpacity } from 'react-native';
import React, { useState, useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { tdsActions } from './tdsRedux/tds.actions';
import { backgroundTdsArr } from './backgroundTdsArr';
import { navigateAction, replaceAction } from '../../helpers/navigationHelpers';
import BackGroundGenerator from '../LandingPages/common/BackGroundGenerator';
import CustomTextInput from '../../commonComponents/customTextInput/customTextInput';
import DatePickerComponent from '../../commonComponents/datepicker/DatePickerComponent';
import {
  Container,
  ButtonWrapper,
  RowContainer,
  Section,
  FormText,
  Heading,
  SubHeading,
  ActivateButtonWrapper,
  primaryColor,
  Typography,
  BoxShadow,
  DownloadButtonWrapper,
} from './style';
import TdsLogin from './login';
import { MainSection } from '../openFlow/style';
import getPlatformType from '../../helpers/getPlatform';
import { tdsLocationSelected } from '../../redux/actions/app';
import { useIsFocused } from '@react-navigation/native';
import { COLORS } from '../../constants/colorPallete';
import { ODSText } from '../../../openbrix-design-system/ui/atoms/ODSText';
import ODSButton from '../../../openbrix-design-system/ui/atoms/ODSButton/index.native';
import { ODSInput } from '../../../openbrix-design-system/ui/atoms/ODSInput';
import { useTheme } from '@emotion/react';
const layoutType = getPlatformType();
const searchDeposit = (props) => {
  const { navigation } = props;
  const dispatch = useDispatch();
  const [type, setType] = useState('web');
  const [showError, setShowError] = useState(false);
  const [state, setState] = useState({ deposit_start_date: null });
  const [searchDeposits, setSearchDeposit] = useState();
  const { colors } = useTheme();
  const tdsLocationSelected2 = useSelector((state) => state.appReducer?.tdsLocationSelected);

  const searchDepositResponse = useSelector((state) => state.tds?.searchedDeposit);
  const focus = useIsFocused();
  const isTdsNi = tdsLocationSelected2 == "TDS_NI"
  useEffect(() => {
    setSearchDeposit();
  }, [focus]);

  const [activeTab, setActiveTab] = useState(props?.route?.params?.tab || 'search');

  const handleChange = (value, field) => {
    setState({ ...state, [field]: value });
  };

  const searchDeposit = () => {
    setShowError(false);
    if (state?.deposit_start_date == null) {
    }
    const region = isTdsNi ? 'ni' : tdsLocationSelected2 === 'TdsScoctland' ? 'scotland' : 'england';
    const deposit_postcode = (state?.dan ? state?.dan_postcode : state?.details_postcode)
      || state?.dan_postcode
      || state?.details_postcode
      || state?.dan_postcode;

    const payload = {
      ...state,
      deposit_postcode,
      region,
    };
    delete payload.dan_postcode;
    delete payload.details_postcode;

    dispatch(tdsActions.searchDeposit(payload, isTdsNi));
  };

  useEffect(() => {
    if (searchDepositResponse) {
      setSearchDeposit(searchDepositResponse);
    } else if (searchDepositResponse?.status == false && searchDepositResponse?.message) {
      setSearchDeposit({ deposit_protected: false });
    }
  }, [searchDepositResponse]);

  const renderInfoBox = () => {
    const type = searchDeposits?.deposit_protected;
    const text = searchDeposits?.deposit_protected
      ? searchDeposits.scheme == 'custodial'
        ? 'Your Deposit is Protected with TDS Custodial '
        : 'Your Deposit is protected with TDS insured.'
      : 'Deposit not found';
    return (
      <>
        <View
          style={{
            width: '100%',
            backgroundColor: type ? searchDeposits.scheme == 'custodial' ? '#DFFFF0' : '#001A96' : 'white',
            justifyContent: 'center',
            alignItems: 'center',
            paddingVertical: 24,
            marginTop: 40,
            marginBottom: 24,
            borderRadius: 19,
            borderColor: type ? '#62D6A0' : '#F44D3F',
            borderWidth: type ? searchDeposits.scheme == 'custodial' ? 2 : 0 : 2,
          }}
          id={'TDS-INFO-BOX'}
        >
          {/* <Text
            style={{
              color: type ? '#4C664B' : '#5E0D0D',
              fontSize: 23,
              fontWeight: '600',
              textAlign: 'center',
            }}
          >
            {' '}
            {text ? text : ''}
          </Text> */}
          <ODSText textAlign='center' type='sm-bold' color={searchDeposits?.scheme == 'insured' ? 'white' : colors.text.primary}>{text ? text : ''}</ODSText>

          {searchDeposits?.certificate ? (
            <ODSButton
              restStyle={{ backgroundColor: 'white', marginTop: 20 }}
              btnCOlor={'#2B3541'}
              onPress={() => window.open(searchDeposits?.certificate, '_blank')}
            >
              Download Certificate
            </ODSButton>
            // <DownloadButtonWrapper
            //   style={{
            //     width: layoutType == 'phone' ? '100%' : 250,
            //     backgroundColor: 'white',
            //     borderColor: '#4D8761',
            //     borderWidth: 1,
            //   }}
            //   id={'TDS-CERTIFICATE-DOWNLOAD'}
            //   onPress={() => window.open(searchDeposits?.certificate, '_blank')}
            // >
            //   <Typography color={'#4C664B'} underline size={'16px'} bold={800}>
            //     DOWNLOAD CERTIFICATE
            //   </Typography>
            // </DownloadButtonWrapper>
          ) : null}
        </View>
        {searchDeposits?.deposit_protected ? (
          searchDeposits.scheme == 'custodial' ? (
            <View style={{ alignItems: 'center' }}>
              <ODSText textAlign='center' type='sm' color={colors.text.primary}>{`Your deposit is protected with the TDS.

Please log in with your email to manage your deposit.`}</ODSText>
            </View>
          ) : (
            <View style={{ alignItems: 'center' }}>
              <ODSText textAlign='center' type='sm' color={colors.text.primary}>{`Your deposit is protected within the TDS insured scheme.`}</ODSText>
            </View>
          )
        ) : (
          <View style={{ alignItems: 'center' }}>
            <ODSText textAlign='center' type='sm' color={colors.text.primary}>{`Please check the information provided is correct.

Alternatively please contact your Agent or Landlord directly to check your deposit is protected with TDS.`}</ODSText>
          </View>
        )}
      </>
    );
  };
  function checkValue(value) {
    handleChange(handleDecimalsOnValue(value), 'deposit_amount');
  }

  function handleDecimalsOnValue(value) {
    const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;
    return value.match(regex)[0];
  }
  const renderSearchDeposit = () => {
    return (
      <Fragment style={{ alignItems: 'center' }}>
        <ODSText marginBottom={30} type='h6-light' color='#000' textAlign='center'>Check if your deposit is protected by entering your details below.</ODSText>
        <ODSInput
          placeholder='Certificate Code/DAN Number'
          value={state?.dan}
          onChange={(value) => handleChange(value, 'dan')}
        />
        <ODSInput
          placeholder='Postcode'
          value={state?.dan_postcode}
          onChange={(value) => handleChange(value, 'dan_postcode')}
        />
        <Image
          style={{ height: 30, width: '100%', marginVertical: 20 }}
          source={require('./web/orSaperator.svg')}
        />
        <View style={{ gap: 8 }}>
          <ODSInput
            keyboardType='numeric'
            placeholder='Deposit Amount'
            value={state?.deposit_amount}
            onChange={(value) => checkValue(value)}
          />
          <ODSInput
            placeholder='Postcode'
            value={state?.details_postcode}
            onChange={(value) => handleChange(value, 'details_postcode')}
          />
          <ODSInput
            placeholder='Tenant Surname'
            value={state?.tenant_surname}
            onChange={(value) => handleChange(value, 'tenant_surname')}
          />
          <DatePickerComponent
            key="datepicker"
            placeholderText={'Tenancy Start Date'}
            boxStyle={{ backgroundColor: colors.neutral[100], marginTop: 14, height: 44, paddingHorizontal: 12, borderRadius: 4, justifyContent: 'center', width: '100%', borderWidth: 1, borderColor: colors.other['border-neutral'] }}
            value={state?.deposit_start_date}
            onUpdateInput={(date) => {
              handleChange(moment(date).format('DD/MM/YYYY'), 'deposit_start_date');
            }}
          />

        </View>

        <ODSButton
          restStyle={{ width: layoutType == "phone" ? "100%" : "70%", marginTop: 40, backgroundColor: '#FF41C0', height: 44, alignSelf: 'center' }}
          txtSize={18}
          onPress={() => searchDeposit()}
        >
          Search
        </ODSButton>

        {searchDeposits ? renderInfoBox() : null}
      </Fragment>
    );
  };
  const renderHeaderContent = () => {
    return (
      <MainSection
        style={{
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignSelf: 'center',
          width: layoutType == 'phone' ? '92%' : 652,
        }}
      >
        <View
          style={{
            width: '100%',
            alignSelf: 'center',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <ODSText type='h3' textAlign='center' color='white'>View & Manage your tenancy deposit</ODSText>
          <ODSText marginTop={20} textAlign='center' type='md' color='white'>{`View the details of your existing deposit protected with the \n government approved Tenancy Deposit Scheme.`}</ODSText>
          <ODSButton
            restStyle={{ width: 266, backgroundColor: '#009DFA', marginTop: 40 }}
            txtSize={22}
            onPress={() => {
              navigateAction(navigation, 'tdsLocation');
              dispatch(tdsLocationSelected(null));
            }}
          >
            Switch Regions
          </ODSButton>
          <ODSText marginTop={16} textAlign='center' type='xs' color='white'>{`Please click here if your property is located in another region of the UK`}</ODSText>
        </View>
      </MainSection>
    );
  };
  return (
    <>
      <BackGroundGenerator
        replace={'Dashboard'}
        isBack={true}
        backNavigation={() => replaceAction(navigation, 'Dashboard')}
        isTds
        props={props}
        layoutType={(data) => {
          setType(data);
        }}
        isTLYF
        paddingtop={layoutType == 'phone' ? 200 : 90}
        backgroundArr={backgroundTdsArr}
      >
        {renderHeaderContent()}
        <MainSection
          style={{
            flexDirection: layoutType == 'phone' ? 'column' : 'row',
            justifyContent: 'space-between',
            marginTop: 10,
            width: layoutType == 'phone' ? '92%' : '80%',
            maxWidth: 1200,
            alignSelf: 'center',
          }}
        >
          {layoutType == 'phone' ? (
            <View style={{ width: '100%' }}>
              {/* Tab Navigation Bar for Mobile */}
              <View
                style={{
                  flexDirection: 'row',
                  backgroundColor: '#F1F5F9',
                  borderRadius: 12,
                  padding: 4,
                  marginBottom: 16,
                  width: '100%',
                }}
              >
                <TouchableOpacity
                  activeOpacity={0.8}
                  onPress={() => setActiveTab('search')}
                  style={{
                    flex: 1,
                    paddingVertical: 12,
                    borderRadius: 8,
                    alignItems: 'center',
                    backgroundColor: activeTab === 'search' ? '#FFFFFF' : 'transparent',
                    shadowColor: activeTab === 'search' ? '#000' : 'transparent',
                    shadowOffset: { width: 0, height: 1 },
                    shadowOpacity: activeTab === 'search' ? 0.1 : 0,
                    shadowRadius: 2,
                    elevation: activeTab === 'search' ? 2 : 0,
                  }}
                >
                  <ODSText
                    type={activeTab === 'search' ? 'sm-bold' : 'sm'}
                    color={activeTab === 'search' ? '#FF41C0' : colors.text.secondary}
                  >
                    Search Deposit
                  </ODSText>
                </TouchableOpacity>

                <TouchableOpacity
                  activeOpacity={0.8}
                  onPress={() => setActiveTab('login')}
                  style={{
                    flex: 1,
                    paddingVertical: 12,
                    borderRadius: 8,
                    alignItems: 'center',
                    backgroundColor: activeTab === 'login' ? '#FFFFFF' : 'transparent',
                    shadowColor: activeTab === 'login' ? '#000' : 'transparent',
                    shadowOffset: { width: 0, height: 1 },
                    shadowOpacity: activeTab === 'login' ? 0.1 : 0,
                    shadowRadius: 2,
                    elevation: activeTab === 'login' ? 2 : 0,
                  }}
                >
                  <ODSText
                    type={activeTab === 'login' ? 'sm-bold' : 'sm'}
                    color={activeTab === 'login' ? '#FF41C0' : colors.text.secondary}
                  >
                    Account Login
                  </ODSText>
                </TouchableOpacity>
              </View>

              {/* Tab Content */}
              {activeTab === 'search' ? (
                <BoxShadow style={{ paddingVertical: 24, paddingHorizontal: 16 }}>
                  {renderSearchDeposit()}
                </BoxShadow>
              ) : (
                <BoxShadow style={{ paddingVertical: 24, paddingHorizontal: 16 }}>
                  <TdsLogin isTdsNi={isTdsNi} navigation={navigation} />
                </BoxShadow>
              )}
            </View>
          ) : (
            <>
              <View style={{ flex: 0.48 }}>
                <BoxShadow style={{ paddingVertical: 40, paddingHorizontal: 32 }}>
                  {renderSearchDeposit()}
                </BoxShadow>
              </View>
              <View style={{ flex: 0.48 }}>
                <BoxShadow style={{ paddingVertical: 40, paddingHorizontal: 32 }}>
                  <TdsLogin isTdsNi={isTdsNi} navigation={navigation} />
                </BoxShadow>
              </View>
            </>
          )}
        </MainSection>
      </BackGroundGenerator>
    </>
  );
};

export default searchDeposit;
